import React from 'react';
import styled from 'styled-components';

const GradientBackground = ({ children, showDecorations = true }) => {
    return (
        <Container>
            <Background />
            {showDecorations && (
                <>
                    <BlobOne />
                    <BlobTwo />
                </>
            )}
            <Content>
                {children}
            </Content>
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    min-height: 100vh;
    width: 100%;
    overflow: hidden;
`;

const Background = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        135deg,
        #F5F5FA 0%,
        #F3E5F5 100%
    );
    z-index: 0;


`;

const BlobOne = styled.div`
    position: absolute;
    top: -100px;
    right: -100px;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background-color: rgba(130, 22, 146, 0.4); /* Increased opacity */
    filter: blur(100px);
    z-index: 1;
`;

const BlobTwo = styled.div`
    position: absolute;
    bottom: -50px;
    left: -50px;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: rgba(78, 59, 201, 0.3); /* Increased opacity */
    filter: blur(80px);
    z-index: 1;
`;

const Content = styled.div`
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export default GradientBackground;
